import React from 'react';
import S from './Input.module.css';

const Input = ({ className, ...props }) => {
  return (
    <input
      {...props}
      className={S[className]}
    />
  );
};

export default Input;